import React from 'react';
import { Button } from '@fiverr-private/button';
import { Stack } from '@fiverr-private/layout_components';
import { I18n } from '@fiverr-private/i18n-react';
import pathfinder from '@fiverr-private/pathfinder';
import { BriefDisplayStatus } from '@fiverr-private/dynamic_matching';
import { buyerClickedBriefDrawerCta } from '../../../monitoring/bqEvents';
import type BuyerBriefResponse from '../../../types/BuyerBriefResponse';

interface ControlProps {
  briefId: BuyerBriefResponse['id'];
  hasPreviousInvites: boolean;
  briefDisplayStatus: BriefDisplayStatus;
  status: BuyerBriefResponse['status'];
}

const getButtonConfig = (briefId: string, briefDisplayStatus: BriefDisplayStatus, hasPreviousInvites: boolean) => {
  const configs = {
    [BriefDisplayStatus.NO_INVITES_SENT]: [
      {
        href: pathfinder('dynamic_matching_management_page', { briefId, tab: 'invite' }),
        labelKey: 'brief_preview_drawer.buyer.footer.invite_freelancers',
      },
    ],
    [BriefDisplayStatus.LIVE]: hasPreviousInvites
      ? [
          {
            href: pathfinder('dynamic_matching_management_page', { briefId, tab: 'offers' }),
            labelKey: 'brief_preview_drawer.buyer.footer.view_offers',
          },
        ]
      : [
          {
            href: pathfinder('dynamic_matching_management_page', { briefId, tab: 'invite' }),
            labelKey: 'brief_preview_drawer.buyer.footer.invite_freelancers',
          },
        ],

    [BriefDisplayStatus.HIRED]: [
      {
        href: pathfinder('dynamic_matching_management_page', { briefId, tab: 'offers' }),
        labelKey: 'brief_preview_drawer.buyer.footer.view_offers',
      },
      { href: pathfinder('pro_orders_page'), labelKey: 'brief_preview_drawer.buyer.footer.view_order' },
    ],
  };

  return configs[briefDisplayStatus] || [];
};

export const Controls: React.FC<ControlProps> = ({ briefId, status, briefDisplayStatus, hasPreviousInvites }) => {
  const buttons = getButtonConfig(briefId, briefDisplayStatus, hasPreviousInvites);

  if (!buttons.length) {
    return null;
  }

  return (
    <Stack gap="4" justifyContent="flexEnd">
      {buttons.map(({ href, labelKey }, index) => (
        <Button
          key={index}
          href={href}
          variant={buttons.length > 1 && index === 0 ? 'ghost' : 'filled'}
          onClick={() => buyerClickedBriefDrawerCta({ briefId, clickedOn: labelKey, status })}
        >
          <I18n k={labelKey} />
        </Button>
      ))}
    </Stack>
  );
};
